import { render } from "./OrdersTable.vue?vue&type=template&id=f276db3e&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=f276db3e&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f276db3e"]])

export default __exports__